import AddProtectedEnvironmentsTable from './AddProtectedEnvironmentsTable';

export default AddProtectedEnvironmentsTable;
export * from './AddProtectedEnvironmentsTable';
